import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var FavoriteIcon = function FavoriteIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "FavoriteIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M8 1.5c.289 0 .553.162.684.418l1.745 3.42 3.912.554a.766.766 0 0 1 .419 1.313l-2.816 2.654.663 3.743a.76.76 0 0 1-.299.748.77.77 0 0 1-.805.066L8 12.634l-3.503 1.782a.77.77 0 0 1-.805-.066.76.76 0 0 1-.3-.748l.664-3.743L1.24 7.205a.763.763 0 0 1 .42-1.313l3.911-.553 1.745-3.42A.77.77 0 0 1 8 1.5m0 2.452L6.758 6.387a.77.77 0 0 1-.576.41l-2.731.386L5.41 9.03a.76.76 0 0 1 .228.69l-.467 2.636 2.48-1.262a.77.77 0 0 1 .697 0l2.48 1.262-.468-2.637a.76.76 0 0 1 .228-.689l1.96-1.847-2.73-.386a.77.77 0 0 1-.577-.41z",
      clipRule: "evenodd"
    })
  }));
};

export { FavoriteIcon };
